import { useState } from "react";
import Banner from "./../../components/Banner/Banner";
import "./Contact.scss";
import axios from "axios";

export default function Contacto() {
  const [values, setValues] = useState({
    Nombre: "",
    Telefono: "",
    Email: "",
    Asunto: "",
    Mensaje: "",
  });

  const [errors, setErrors] = useState({
    Nombre: "",
    Telefono: "",
    Email: "",
    Asunto: "",
    Mensaje: "",
  })

  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const sendEmail = async () => {

    setLoading(true);
    const { Nombre, Email, Asunto, Mensaje, Telefono } = values;

    const formValues = Object.entries(values);
    let newErrors = {};
    for (const [key, val] in formValues) {
        const message = `Debe ingresar ${formValues[key][0]}`;
        const name = formValues[key][0];
        if (formValues[key][1] === "") {        
            newErrors[name] = message;
        } else {
            newErrors[name] = '';
        }
    }

    const hasErrors = Object.values(newErrors).every( item => item === '');

    if (!hasErrors) {
        setErrors({...newErrors});
        setLoading(false);
        return;
    }

    const formData = new FormData();
    formValues.forEach( item => formData.append(item[0], item[1]));
    const BASE_URL = "http://jpf.cl";
    const res = await axios.post(`${BASE_URL}/contact.php`, formData);

    if (res.data.status) {
        setValues({
            Nombre: "",
            Telefono: "",
            Email: "",
            Asunto: "",
            Mensaje: "",
        })
        setMessage(res.data.data);
        setTimeout(() => {
          window.location.reload();
        }, 1500)
    }

    setLoading(false);

  };
  const handleInputChange = ({ target }) => {
    setValues({
      ...values,
      [target.name]: target.value,
    });
  };
  return (
    <>
      <Banner visible={false} />
      <div className="main my-5">
        <div className="container">
          <div className="content-contact">
            <div className="row">
              <div className="col-md-6">
                <h3 className="title">
                  Escribeme <div className="line"></div>
                </h3>
                { message != "" ? 
                    <>
                        <div class="alert alert-success">
                            {message}
                        </div>
                    </> : <></>
                }
                <form className="form">
                  <div className="form-group row">
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control"
                        id="Nombre"
                        name="Nombre"
                        placeholder="Nombre*"
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      />
                      <p className="text-danger">{ errors.Nombre }</p>
                    </div>
                    <div className="col-sm-6">
                      <input
                        type="tel"
                        className="form-control"
                        id="Telefono"
                        name="Telefono"
                        placeholder="Teléfono"
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      />
                      <p className="text-danger">{ errors.Telefono }</p>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-sm-6">
                      <input
                        type="email"
                        className="form-control"
                        id="Email"
                        name="Email"
                        placeholder="Email*"
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      />
                      <p className="text-danger">{ errors.Email }</p>
                    </div>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control"
                        id="Asunto"
                        name="Asunto"
                        placeholder="Asunto"
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      />
                      <p className="text-danger">{ errors.Asunto }</p>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-sm-12">
                      <textarea
                        className="form-control"
                        id="Mensaje"
                        name="Mensaje"
                        placeholder="Mensaje..."
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      ></textarea>
                      <p className="text-danger">{ errors.Mensaje }</p>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-sm-12 text-end">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={async () => {
                          sendEmail();
                        }}
                        disabled={loading}
                      >
                        Enviar
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-md-1"></div>
              <div className="col-md-5">
                <h3 className="title">
                  Datos de contacto <div className="line"></div>
                </h3>
                <div className="content">
                  <span className="bold">Estudio</span> :{" "}
                  <span>Calle Nueva 1757, Huechuraba</span>
                  <br />
                  <span>Región Metropolitana, Chile</span>
                </div>
                <div className="content">
                  <span className="bold">Email</span> :{" "}
                  <span>jpf@jpfcine.cl</span>
                </div>
                <div className="content">
                  <span className="bold">Teléfono</span> :{" "}
                  <span>+562 22862 6800</span>
                </div>
                <h3 className="title mt-5">
                  Datos de Agente <div className="line"></div>
                </h3>
                <div className="content">
                  <span className="bold">Email</span> :{" "}
                  <span>hector@antuaudiovisual.cl</span>
                </div>
                <div className="content">
                  <span className="bold">Teléfono</span> :{" "}
                  <span>+569 9874 6471</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
